"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../css/password_strength.css");

var _animated_height = _interopRequireDefault(require("./shared/animated_height"));

var _password_strength_item = _interopRequireDefault(require("./password_strength_item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PasswordStrength = function PasswordStrength(_ref) {
  var error = _ref.error,
      requirementsErrorTitle = _ref.requirementsErrorTitle,
      requirements = _ref.requirements,
      showRequirements = _ref.showRequirements;
  return _react.default.createElement("div", {
    className: "vn-password-strength__container"
  }, error && !showRequirements && _react.default.createElement(_password_strength_item.default, {
    error: true,
    title: requirementsErrorTitle
  }), _react.default.createElement(_animated_height.default, {
    in: showRequirements
  }, requirements.map(function (requirement) {
    return _react.default.createElement("div", null, requirement.error === true && _react.default.createElement(_password_strength_item.default, {
      main: true,
      error: requirement.error,
      title: requirement.title
    }), requirement.error === undefined && _react.default.createElement(_password_strength_item.default, {
      main: true,
      checked: requirement.checked,
      title: requirement.title
    }, requirement.requirements && requirement.requirements.map(function (req) {
      return _react.default.createElement(_password_strength_item.default, {
        checked: req.checked,
        title: req.title
      });
    })));
  })));
};

PasswordStrength.propTypes = {
  error: _propTypes.default.bool,
  requirements: _propTypes.default.arrayOf(_password_strength_item.default),
  requirementsErrorTitle: _propTypes.default.string,
  showRequirements: _propTypes.default.bool
};
PasswordStrength.defaultProps = {
  error: false,
  requirements: undefined,
  requirementsErrorTitle: 'Check password requirements',
  showRequirements: true
};
PasswordStrength.displayName = 'PasswordStrength';
var _default = PasswordStrength;
exports.default = _default;